// extracted by mini-css-extract-plugin
export default {"carousel_container":"MediaRecommendations_carousel_container__9GVUI","section_card":"MediaRecommendations_section_card__2FCFQ"};